import styles from './Divider.module.scss'

export const Divider = ({ color, customClass }) => {
  return (
    <hr
      className={`${styles.divider} ${styles[`divider--${color}`]} ${customClass}`}
    />
  )
}
